import { NoteNode, NoteDetail, Connection, colorForType } from './types'

interface SidePanelProps {
  detail: NoteDetail | null
  connections: Connection[]
  loading: boolean
  selectedId: string | null
  nodeMap: Map<string, NoteNode>
  onClose: () => void
  onSelectConnection: (id: string) => void
}

export default function SidePanel({
  detail,
  connections,
  loading,
  selectedId,
  nodeMap,
  onClose,
  onSelectConnection,
}: SidePanelProps) {
  if (!selectedId) return null

  // Vecinos únicos (la API devuelve edges en ambas direcciones)
  const neighbors = (() => {
    const seen = new Set<string>()
    const out: { id: string; weight: number; type: string }[] = []
    connections.forEach((c) => {
      const otherId =
        c.source_note_id === selectedId ? c.target_note_id : c.source_note_id
      if (otherId === selectedId || seen.has(otherId)) return
      seen.add(otherId)
      out.push({ id: otherId, weight: c.weight, type: c.relationship_type })
    })
    return out.sort((a, b) => b.weight - a.weight)
  })()

  return (
    <aside className="side-panel">
      <button className="panel-close" onClick={onClose} aria-label="Cerrar">
        ×
      </button>

      {loading && <div className="panel-loading">Cargando nota…</div>}

      {!loading && detail && (
        <>
          <div className="panel-type">
            <span
              className="type-dot"
              style={{ background: colorForType(detail.note_type) }}
            />
            {detail.note_type}
          </div>

          <h2 className="panel-title">{detail.title}</h2>

          {detail.tags && detail.tags.length > 0 && (
            <div className="panel-tags">
              {detail.tags.map((t) => (
                <span key={t} className="tag">
                  #{t}
                </span>
              ))}
            </div>
          )}

          <div className="panel-content">{detail.content}</div>

          <div className="panel-section-title">
            Conexiones ({neighbors.length})
          </div>
          <ul className="panel-connections">
            {neighbors.length === 0 && (
              <li className="conn-empty">Sin conexiones</li>
            )}
            {neighbors.map((n) => {
              const node = nodeMap.get(n.id)
              return (
                <li key={n.id}>
                  <button
                    className="conn-link"
                    onClick={() => onSelectConnection(n.id)}
                    title={node?.title || n.id}
                  >
                    <span
                      className="type-dot small"
                      style={{
                        background: colorForType(node?.note_type || ''),
                      }}
                    />
                    <span className="conn-title">
                      {node?.title || 'Nota desconocida'}
                    </span>
                    <span className="conn-weight">{n.weight.toFixed(2)}</span>
                  </button>
                </li>
              )
            })}
          </ul>
        </>
      )}

      {!loading && !detail && (
        <div className="panel-loading">No se pudo cargar la nota.</div>
      )}
    </aside>
  )
}
